import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getOperators } from '../../services'
import { AdminQueryKey } from '@/modules/admin/keys'
import {
	GetOperatorsRequest,
	GetOperatorsResponse,
} from '@/modules/manage-operator/types'

export default function useQueryGetOperators(
	payload: GetOperatorsRequest,
	props?: UseBaseQueryOptions<GetOperatorsResponse>,
) {
	return useQuery({
		queryKey: [AdminQueryKey.GetOperators, payload],
		queryFn: () => getOperators(payload),
		...props,
	})
}
